/**
 * Formats a raw string into XX-XXXXXXX EIN format as the user types.
 * Strips all non-digits, caps at 9, inserts dash after position 2.
 */
export function formatEIN(raw: string): string {
  const digits = raw.replace(/\D/g, "").slice(0, 9);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}-${digits.slice(2)}`;
}

/**
 * Returns the bare digit string for validation (e.g. "612024953").
 */
export function normalizeEIN(value: string): string {
  return value.replace(/\D/g, "");
}
